import { fromJS } from 'immutable';
import { uniq } from 'lodash';
import * as types from './constants';

const initState = fromJS({
  lang: localStorage.getItem('language') || 'en',
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.CHANGE_LANGUAGE: {
      return state.set('lang', payload);
    }
    default:
      return state;
  }
};
